import { delay, getTransitionDuration } from '../../utils/utils'
import FloatElement from './float-element'

class HotspotsFloatElement extends FloatElement {
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.styles = getComputedStyle(this)
  }

  unmount() {
    return delay(getTransitionDuration(this.styles)).then(() => {
      super.unmount()
    })
  }
}

export default HotspotsFloatElement
